<template>
  <el-card class="box-card">
    <!-- <div slot="header" class="clearfix">
	</div> -->
    <el-collapse-item name="1" class="top">
      <template slot="title">
        <slot name="title"></slot>
        <div class="title-des">
          {{ $t("message.title.totalResults") + tableInfo.length + $t("message.title.resultsNums") }}
        </div>
      </template>
      <transition name="slide-fade" class="right">
        <div style="width: 100%;">
          <el-table border :data="tableInfo" style="width: 100%" @row-click="tablistClick" class="table"
            max-height="300" :row-class-name="tableRowClassName">

            <el-table-column :label="$t('message.table.number_')" width="150" prop="number" sortable resizable>
              <template slot-scope="scope">
                <el-link @click.native.prevent="clickRow(scope.row)" style="color: #3ea0fb">{{ scope.row.number
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column sortable resizable prop="des" min-width="200"
              :label="$t('message.table.changeDes')"></el-table-column>
            <el-table-column sortable resizable prop="hasReject"
              :label="$t('message.table.rejected')"></el-table-column>
            <el-table-column sortable resizable prop="statusLabel"
              :label="$t('message.table.changeStatus')"></el-table-column>
            <el-table-column sortable resizable prop="workflow" :label="$t('message.table.workflow')"></el-table-column>
            <el-table-column sortable resizable prop="submitDate"
              :label="$t('message.table.submitDate')"></el-table-column>
            <el-table-column sortable resizable prop="createDate"
              :label="$t('message.table.createdDate')"></el-table-column>
            <el-table-column sortable resizable prop="completeDate"
              :label="$t('message.table.completedDate')"></el-table-column>
            <el-table-column :label="$t('message.table.actions')" min-width="60" sortable resizable>
              <slot></slot>
            </el-table-column>
            <!-- <el-dialog title="批准发布" :visible.sync="approveWindow">
				<model @subData = 'xx'  ref="approveModel"></model>
			</el-dialog>
			<el-dialog title="驳回发布" :visible.sync="rejectWindow">
				<model></model>
			</el-dialog>	 -->
          </el-table>
        </div>

      </transition>
    </el-collapse-item>
  </el-card>
</template>

<script>
// import model from "./model.vue";
export default {
  data() {
    return {
      approveWindow: false,
      rejectWindow: false,
    };
  },
  props: ["tableInfo"],
  // components: { model },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      // console.log(row.hasReject);

      if (row.hasReject) {
        return 'warning-row'
      } else {
        if (rowIndex % 2) {
          return 'stripe-row';
        }
        return ''
      }
    },
    clickRow(row) {
      const obj = row.seriesId;
      obj.title = row.number;
      this.getLink(obj);
    },

    tablistClick(row, column, event) {
      this.$emit("rowDataShow", row);
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  overflow: auto;
  table-layout: fixed;
}

.title-des {
  margin-left: 15px;
  margin-top: 3px;
}
</style>
<style>
.el-table .warning-row {
  background-color: #fef0f0;
  border-color: #fde2e2;
  /* color: #f56c6c; */
}

.el-table .stripe-row {
  background-color: #fafafa;
  border-color: #ebeef5;
}
</style>
